import type { DateRange } from "react-day-picker"
import { startOfToday, subMonths, addMonths } from "date-fns"

export type QuickSelectFilter = {
  label: string
  resolve: (minDate?: Date, maxDate?: Date) => DateRange | undefined
}

export const DEFAULT_QUICK_SELECTS: QuickSelectFilter[] = [
  {
    label: "Previous 6 months and next 6 months",
    resolve: () => {
      const today = startOfToday()
      return { from: subMonths(today, 6), to: addMonths(today, 6) }
    },
  },
  {
    label: "Previous 12 months and next 12 months",
    resolve: () => {
      const today = startOfToday()
      return { from: subMonths(today, 12), to: addMonths(today, 12) }
    },
  },
  {
    label: "Full horizon",
    resolve: (minDate, maxDate) => {
      if (!minDate || !maxDate) return undefined
      return { from: minDate, to: maxDate }
    },
  },
]
